import React from "react";
import { classNames } from "../../../../../helpers/classNames";
import Tooltip from "../../../Tooltip";

const EditorButton = ({
  onClick = () => {},
  isActive,
  children,
  title,
  className,
}) => {
  return (
    <Tooltip message={title}>
      <button
        onClick={onClick}
        className={classNames(
          "flex items-center justify-center p-[2px] overflow-hidden h-9 w-9 rounded-md transition-colors duration-200 hover:!bg-gray-100",
          "focus:outline-none focus:ring-0",
          isActive ? "bg-gray-200 text-gray-800" : "",
          className
        )}
      >
        {children}
      </button>
    </Tooltip>
  );
};

export default EditorButton;
